import styled from 'styled-components';

// Image
import BackgroundImage from '../../../assets/background-login.jpg';

export const Container = styled.div`
  background: url(${BackgroundImage}) no-repeat center center;
  background-size: cover;
  min-width: 100vw;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const BoxContainer = styled.div`
  width: 50rem;
  min-height: auto;
  max-height: 85vh;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 1.5rem;
  padding: 4rem 5rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  /* Tablet landscape - 1024px */
  @media (max-width: 1024px) {
    width: 46rem;
    padding: 3.5rem 4.5rem;
  }

  /* Tablet landscape small - 900px */
  @media (max-width: 900px) {
    width: 42rem;
    padding: 3rem 4rem;
  }

  /* Tablet portrait - 768px */
  @media (max-width: 768px) {
    width: 85vw;
    max-width: 40rem;
    min-width: 35rem;
    padding: 2.5rem 3rem;
    max-height: 85vh;
  }

  /* Mobile large - 600px */
  @media (max-width: 600px) {
    width: 90vw;
    max-width: 38rem;
    min-width: 32rem;
    padding: 2.5rem 2.5rem;
    max-height: 90vh;
  }

  /* Mobile small - 480px */
  @media (max-width: 480px) {
    width: 95vw;
    max-width: 35rem;
    min-width: 30rem;
    padding: 2rem 2rem;
    max-height: 95vh;
  }
`;
